import { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';

export default function Resenas() {
  const [resenas, setResenas] = useState([]);
  const [filtro, setFiltro] = useState('todos');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const cargar = () => axios.get(`${API}/resenas/admin`, { headers }).then(r => setResenas(r.data));
  useEffect(() => { cargar(); }, []);

  const aprobar = async (id: number) => {
    await axios.put(`${API}/resenas/${id}/aprobar`, {}, { headers });
    cargar();
  };

  const rechazar = async (id: number) => {
    await axios.put(`${API}/resenas/${id}/rechazar`, {}, { headers });
    cargar();
  };

  const eliminar = async (id: number) => {
    if (!window.confirm('¿Eliminar esta reseña?')) return;
    await axios.delete(`${API}/resenas/${id}`, { headers });
    cargar();
  };

  const COLORES: any = {
    pendiente: 'bg-yellow-100 text-yellow-700',
    aprobada: 'bg-green-100 text-green-700',
    rechazada: 'bg-red-100 text-red-600'
  };

  const filtradas = filtro === 'todos' ? resenas : (resenas as any[]).filter((r: any) => r.estado === filtro);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Reseñas</h1>
          <p className="text-gray-500 text-sm">{resenas.length} reseñas recibidas</p>
        </div>
        <div className="flex gap-2">
          {['todos','pendiente','aprobada','rechazada'].map(f => (
            <button key={f} onClick={() => setFiltro(f)}
              className={`px-4 py-2 rounded-xl text-xs font-bold border transition-colors capitalize ${filtro === f ? 'bg-azul text-white border-azul' : 'bg-white text-gray-500 border-gray-200 hover:border-azul'}`}>
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {(filtradas as any[]).map((r: any) => (
          <div key={r.id} className={`bg-white rounded-2xl border p-5 transition-colors ${r.estado === 'pendiente' ? 'border-yellow-200' : r.estado === 'aprobada' ? 'border-green-200' : 'border-gray-100'}`}>
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-azul rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0">
                  {r.nombre?.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-azul">{r.nombre}</div>
                  <div className="flex gap-0.5 mt-0.5">
                    {[1,2,3,4,5].map(i => (
                      <span key={i} className={`text-sm ${i <= r.estrellas ? 'text-yellow-400' : 'text-gray-300'}`}>★</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-3 py-1 rounded-full font-bold capitalize ${COLORES[r.estado]}`}>{r.estado}</span>
                <span className="text-gray-400 text-xs">{new Date(r.creado_en).toLocaleDateString('es-CR')}</span>
              </div>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 mb-4">
              <p className="text-gray-700 text-sm leading-relaxed">{r.comentario}</p>
            </div>
            <div className="flex gap-2 justify-end">
              {r.estado !== 'aprobada' && (
                <button onClick={() => aprobar(r.id)} className="bg-green-500 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-green-600 transition-colors">
                  ✅ Aprobar
                </button>
              )}
              {r.estado !== 'rechazada' && (
                <button onClick={() => rechazar(r.id)} className="bg-gray-200 text-gray-600 px-4 py-2 rounded-lg text-xs font-bold hover:bg-gray-300 transition-colors">
                  ❌ Rechazar
                </button>
              )}
              <button onClick={() => eliminar(r.id)} className="text-rojo hover:bg-rojo/10 px-4 py-2 rounded-lg text-xs font-bold transition-colors">
                🗑️ Eliminar
              </button>
            </div>
          </div>
        ))}
        {filtradas.length === 0 && (
          <div className="text-center py-16 text-gray-400 bg-white rounded-2xl border border-gray-100">
            <div className="text-4xl mb-3">⭐</div>
            <p>No hay reseñas {filtro !== 'todos' ? `con estado "${filtro}"` : 'aún'}</p>
          </div>
        )}
      </div>
    </div>
  );
}
